export const UserRoleEnum = {
    CONTRACTOR: 'contractor',
    ARCHITECTOR: 'architector',
    SAU: 'SAU',
    MAU: 'MAU',
    CUSTOMER: 'Customer',
} as const;

export type UserRoleType = (typeof UserRoleEnum)[keyof typeof UserRoleEnum];
